module.exports = __webpack_public_path__ + "img/5_of_Hearts.svg.fb37d235.png";